import * as devisConf from '@/configuration/devisConf';

export default function ajoutOrdre(ligne, index, baseOrdre) {
  if (baseOrdre) ligne.ordre = baseOrdre;
  else ligne.ordre = Math.round(index * 100);
  if (ligne.type !== devisConf.REGROUPEMENT) {
    return;
  }
  let ordre = ligne.ordre;
  ligne.lignesCommande.forEach(ligneCommande => {
    ordre += 1;
    ligneCommande.ordre = ordre;
  });
}
